import { FC } from "react";

import { MapLibreAutoPanPopup } from "@ryde/controls";
import { ICoordinate } from "@ryde/shared";

import { LANDING_ADDRESS_MAP_POPUP_OFFSET_PX } from "./landing-constant";

interface ILandingAddressMapPopupProps {
  coordinate: ICoordinate;
  text: string;
  onClose: () => void;
}

/**
 * The label a marker opens when clicked.
 *
 * Its own component, rather than inline in the map, because the popup's auto-pan reaches the map through
 * `@vis.gl/react-maplibre`'s context — it only resolves for a component rendered *inside* the map, and
 * at all from the component that renders the map itself.
 *
 * Mounted only while open, hence the constant `isOpen`.
 */
export const LandingAddressMapPopup: FC<ILandingAddressMapPopupProps> = ({
  coordinate,
  text,
  onClose,
}) => (
  <MapLibreAutoPanPopup
    isOpen
    latitude={coordinate.lat}
    longitude={coordinate.lng}
    // Lifted clear of the landing pin, which is taller than the station pin the default clears.
    offset={LANDING_ADDRESS_MAP_POPUP_OFFSET_PX}
    onClose={onClose}
  >
    {text}
  </MapLibreAutoPanPopup>
);
